import React, { useState } from "react";
import { Link } from "gatsby";
import { GatsbyImage, StaticImage, getImage } from "gatsby-plugin-image";
import { NewsData } from "../hooks/NewsArticles";

const NewsArticle = ({ article }) => {
  const image = getImage(article.feat?.node?.img);
  const date = new Date(article.date);
  const formattedDate = `${date.getDate()}-${date.getMonth() + 1}-${date.getFullYear()}`;

  return (
    <div key={article.title} className="block-container sm:flex sm:items-center bg-white transform transition-transform duration-500 hover:scale-105" >
      <Link to={article.uri} className="sm:flex-1">
        {image ?
          <GatsbyImage
            image={image}
            alt=""
            className="block-image w-full max-h-[200px] object-cover rounded-md"
            imgStyle={{ objectFit: 'cover' }}
            width={200}
          />
          :
          <StaticImage
            src="../images/fallbacks/article-fallback.png"
            className="block-image max-h-[200px] rounded-lg hover:shadow-lg transition-shadow duration-200"
            width={200}
            alt={article.title || ""}
          />
        }
        <div className="block-text text-sm sm:text-base bg-white wba-green px-4 py-2">
          <h6 className="font-bold text-center">{article.title}</h6>
        </div>
      </Link>
    </div>

  );
};

const Newsbar = () => {
  const [isOpen, setIsOpen] = useState(false);
  const newsArticles = NewsData().wp.nodes;
  const toggleSidebar = () => setIsOpen(!isOpen);
  const svgIcon = `...`; // Insert your SVG icon here

  const newsbarClass = `news-post ${isOpen ? "opened" : ""}`;

  return (
    <>
      <button
        className="fixed envelope bottom-4 right-4 lg:hidden z-50 bg-wba-green text-white rounded-full p-3 flex items-center justify-center"
        onClick={toggleSidebar}
      >
        <span
          className={`envelope-icon ${isOpen ? "opened" : ""}`}
          dangerouslySetInnerHTML={{ __html: svgIcon }}
        />
        {isOpen ? "Close News" : "Open News"}
      </button>
      <aside
        className={`news transform transition-transform duration-500 ease-in-out ${isOpen ? "translate-x-0" : "lg:translate-x-0 -translate-x-full"
          } relative top-0 right-0 w-64 bg-cover bg-image-url z-10 overflow-y-scroll p-4 bg-white rounded-lg`}
      >
        <h2 className="text-2xl font-bold py-1 upper-case w-full wba-green text-shadow text-center">
          Latest News
        </h2>
        <ul className="articles-list flex flex-col items-center space-y-4 w-full px-2 py-2">
          {newsArticles.map((article, i) => (
            <li key={i}>
              <NewsArticle article={article} />
            </li>
          ))}
        </ul>
        <span className="news-archive-link w-full flex justify-center mt-6">
          <Link
            to="/news-archive"
            className="text-white font-bold upper-case text-base bg-[#114734] rounded-full px-5 py-2"
          >
            News Archive
          </Link>
        </span>
      </aside>
    </>
  );
};
export const StaticNewsBar = () => {
  const newsArticles = NewsData().wp.nodes;
  return (
    <aside
      className={`news w-64 p-4 lg:pt-8 bg-white rounded-lg`}
      style={{
        position:'sticky',
        alignSelf:'start',
        top:'14rem',
      }}
    >
      <h2 className="text-2xl font-bold py-1 upper-case w-full wba-green text-shadow text-center">
        Latest News
      </h2>
      <ul className="articles-list flex flex-col items-center space-y-4 w-full px-2 py-2">
        {newsArticles.map((article, i) => (
          <li key={i}>
            <NewsArticle article={article} />
          </li>
        ))}
      </ul>
      <span className="news-archive-link w-full flex justify-center mt-6">
        <Link
          to="/news-archive"
          className="text-white font-bold upper-case text-base bg-[#114734] rounded-full px-5 py-2"
        >
          News Archive
        </Link>
      </span>
    </aside>
  )

}
export default Newsbar;
